module.exports = __webpack_public_path__ + "img/geofence-blue.bf2f7c50.svg";